<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-21 14:36:31
 * @LastEditTime: 2022-11-21 13:39:29
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/babyWikipedia/index.vue
 *
-->
<template>
  <div class="trial-productsList">
    <keep-alive :include="includes">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<style lang="less" scoped>
.trial-productsList {
  width: 100%;
  min-height: 100%;
  background: linear-gradient(
    2deg,
    #ededed 0%,
    #f8f1ee 52%,
    #fb4651 90%,
    #f95a64 100%
  );
  filter: blur(0px);
}
</style>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import {
  getCookie,
  getUrlParamsByName,
  is_weixin,
  isUserLogin,
  setCookie,
} from '@/assets/js/common.js'

var hasHandlerInfo = false // 是否初始化用户信息
export default {
  name: 'trialProductsIndex',
  components: {},
  data() {
    return {
      isRecommendSwitch: null, // 是否开启了智能推荐
      UserInfo: {}, // 用户信息
      babyInfo: [],
      optionList: [],
    }
  },

  computed: {
    // 在computed中动态监控
    ...mapState({
      includes: (state) => state.includes,
    }),
    babyNums() {
      return localStorage.getItem('babyNums')
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!isUserLogin()) {
      next()
    } else {
      location.href = '/home'
    }
  },
  mounted() {
    this.$store.commit('changeIncludes', [
      'trialProducts',
      'trialProductsIndex',
    ])
  },
  created() {
    this.wxShare()
    this.getMonthsPeriod()
    this.babyInfo = JSON.parse(localStorage.getItem('babyInfo'))
    this.UserInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  methods: {
    //分享

    wxShare() {
      if (location.origin + '/trialProducts' === location.href.split('?')[0]) {
        var shareDataParams = {
          shareLink: location.href.split('#')[0],
          shareDesc: '来做星妈品鉴官，无门槛免费体验多款优选产品～',
          shareTitle: '0元试用，免费申请',
          imgUrl: 'https://image-mom.feihe.com/wxshare/home.png', //必须是绝对路径
        }
        this.wxJsSet.wxShare('fx', shareDataParams, this)
      } else {
        return
      }
    },
    // 判断宝宝状态
    handlerInfo() {
      if (this.babyInfo && this.babyInfo.length != 0) {
        localStorage.setItem('babyNum', this.babyInfo.length) // 存入宝宝的个数
        localStorage.setItem('handleTagBY', '1')

        var babynumBir1 =
          (this.babyInfo.find((item) => item.num == '1') &&
            this.babyInfo.find((item) => item.num == '1').birth) ||
          ''
        var babynumBir2 =
          (this.babyInfo.find((item) => item.num == '2') &&
            this.babyInfo.find((item) => item.num == '2').birth) ||
          ''
        // 判断第几胎月龄最小
        if (getCookie('babyNum')) {
          this.babyCurrentNum = getCookie('babyNum') // 从cookie中获取切换宝宝的胎次
          this.babyCurrentNum = parseInt(this.babyCurrentNum)
        } else {
          if (!!babynumBir1 && !!babynumBir2) {
            // 判断两胎是否都有生日
            // 判断第几胎月龄小
            new Date(babynumBir1).getTime() < new Date(babynumBir2).getTime()
              ? (this.babyCurrentNum = 2)
              : (this.babyCurrentNum = 1)
          } else {
            babynumBir1 && !babynumBir2
              ? (this.babyCurrentNum = 1)
              : babynumBir2
              ? (this.babyCurrentNum = 2)
              : (this.babyCurrentNum = 1)
          }
          setCookie('babyNum', this.babyCurrentNum, 30)
          localStorage.setItem('babyNums', this.babyCurrentNum)
        }
      } else {
        localStorage.setItem('babyNum', 0)
      }
    },
    // 获取月龄段
    getMonthsPeriod() {
      this.$http.get('/babyWikiRevision/monthsPeriod', {}, (res) => {
        if (res.code === '200') {
          this.optionList = [{ name: '全部', id: 0 }]
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].id > 0 && res.data[i].id < 7) {
              this.optionList.push(res.data[i])
            }
          }
          const babyNum = localStorage.getItem('babyNums')
          const babyInfo = JSON.parse(localStorage.getItem('babyInfo'))
          let id =
            babyInfo && babyInfo.length
              ? babyInfo.filter((item) => item.num == babyNum)[0].tag_id
              : null
          if (id == 1) {
            id = 2
          } else if (id == 2) {
            id = 1
          }
          const data = this.optionList.filter((item) => item.id == id)[0]
          localStorage.setItem('babyBuried', JSON.stringify(data ? data : null))
        }
      })
    },
  },

  watch: {
    babyNums: {
      handler(newValue) {
        alert(newValue)
      },
      deep: true,
    },
  },
}
</script>
